import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthenticationService } from '../../services/auth/authentication.service';
import { UsersService } from '../../services/users/users.service';
import { Subscription, Subject, throwError } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ReportsService } from '../../services/reports/reports.service';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-list-interviewers',
  templateUrl: './list-interviewers.component.html',
  styleUrls: ['./list-interviewers.component.scss']
})
export class ListInterviewerComponent implements OnInit, OnDestroy {
  public officers_list = []
  private subs: Array<Subscription> = [];
  private modalContent: any;
  private modalConfig: any = {
    ariaLabelledBy: 'modal-basic'
  };

  public dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<any> = new Subject();
  public deleteIsSuccess = false;
  public userId: string;
  public total: number;
  public page = 1;
  public limit: number = 10;
  public offset: number = 0;
  public textSearch = '';
  public editIsSuccess = false;
  public isLoading = false;


  dtElement: any;
  area = '';
  profile: any;
  departments: any;
  catalogs = [];


  constructor(
    private usersService: UsersService,
    private authService: AuthenticationService,
    private reportsService: ReportsService,
    private userService: UsersService,
    private toastr: ToastrService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      destroy: true,
      language: {
        emptyTable: '',
        zeroRecords: '',
        lengthMenu: 'Mostrar _MENU_ elementos',
        search: 'Buscar:',
        info: 'De _START_ a _END_ de _TOTAL_ elementos',
        infoEmpty: 'De 0 a 0 de 0 elementos',
        infoFiltered: '(filtrados de _MAX_ elementos totales)',
        paginate: {
          first: 'Prim.',
          last: 'Últ.',
          next: 'Sig.',
          previous: 'Ant.'
        },
      },
    };

    this.subs.push(
      this.usersService
        .getOfficers(this.textSearch, this.limit, this.offset)
        .pipe(
          catchError(err => this.authService.handleUnauthorizedError(err))
        )
        .subscribe(data => {
          console.log("-----------------------",data)
          this.officers_list = data.List;
          this.total = data.Total;
          this.rerender();
        }),
      this.reportsService.getValuestoCatalog("Perfil").subscribe(data => {
        // console.log(data)
        this.catalogs = data;
      }),
      this.reportsService.getValuestoCatalog("Departments").subscribe(data => {
        this.departments = data;
      }),

    );
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
    this.subs.forEach(sub => sub.unsubscribe());
  }

  rerender(): void {
    this.dtElement?.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  setModalContent(content: any, userId: string): void {
    this.userId = userId;
    this.modalContent = content;
    this.modalService.open(this.modalContent, this.modalConfig);
  }

  setModalDeleteContent(content: any, userId: string): void {
    this.userId = userId;
    this.deleteIsSuccess = false;
    this.modalContent = content;
    this.modalService.open(this.modalContent, this.modalConfig);
  }

  clearInputs() {
    this.textSearch = '';
    this.ngOnInit();
  }

  getResults() {
    this.subs.push(
      this.usersService
        .getOfficers(this.textSearch, this.limit, this.offset)
        .pipe(
          catchError(err => this.authService.handleUnauthorizedError(err))
        )
        .subscribe(data => {
          this.officers_list = data.List;
          this.total = data.Total;
          this.rerender();
        })
    );
  }

  public loadPage(page: number) {
    this.subs.push(
      this.usersService
        .getOfficers(this.textSearch, this.limit, page - 1)
        .pipe(
          catchError(err => this.authService.handleUnauthorizedError(err))
        )
        .subscribe(data => {
          this.officers_list = data.List;
          this.total = data.Total;
        })
    );
  }


  updateRol() {

    let data = {
      roles: this.profile,
      Area: this.area
    }
    this.subs.push(
      this.userService.updateRole(this.userId, data)
        .pipe(
          map(() => {
            this.handleUpdateRol();
            setTimeout(() => {
              window.location.reload();
            }, 1500);
          }),
        )
        .subscribe()
    );
  }

  public deleteUser() {
    this.subs.push(
      this.usersService.deleteUser(this.userId)
        .subscribe(resolve => {
          if (resolve.active === false) {
            this.handleDeleteUser();
            setTimeout(() => {
              this.modalService.dismissAll();
              window.location.reload();
            }, 1500);
          }
        })
    );
  }

  private handleUpdateRol() {
    this.isLoading = false;
    this.toastr.success('Rol editado correctamente', 'Atención ciudadana', { timeOut: 2500 });
  }

  private handleDeleteUser() {
    this.isLoading = false;
    this.toastr.success('Usuario eliminado correctamente', 'Atención ciudadana', { timeOut: 2500 });
  }
}

